import * as PopoverPrimitive from '@radix-ui/react-popover';

export const PopoverAnchor = PopoverPrimitive.Anchor;
